import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";
import logo from "@/assets/logo-podomasso-clinica-podologia-belem.png";
import { SITE } from "@/lib/site";
import { SERVICES } from "@/lib/services";

export function Footer() {
  return (
    <footer className="border-t border-border bg-secondary/30">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src={logo}
                alt="Podomasso Clínica de Podologia em Belém do Pará"
                className="h-14 w-auto"
                width={56}
                height={56}
              />
              <div>
                <p className="font-display text-xl font-bold">Podomasso</p>
                <p className="text-xs text-muted-foreground">Clínica de Podologia</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Clínica especializada em podologia em Belém do Pará. Cuidando da saúde dos seus pés
              com técnica, carinho e biossegurança rigorosa.
            </p>
            <p className="text-xs font-semibold text-foreground">
              Responsável Técnica: <br />
              {SITE.professional.name} — {SITE.professional.registry}
            </p>
          </div>

          <div>
            <h3 className="mb-4 font-display text-base font-semibold">Navegação</h3>
            <ul className="space-y-2 text-sm">
              {[
                { to: "/" as const, label: "Início" },
                { to: "/sobre" as const, label: "Sobre a clínica" },
                { to: "/servicos" as const, label: "Serviços" },
                { to: "/blog" as const, label: "Blog" },
                { to: "/agendamento" as const, label: "Agendamento" },
                { to: "/contato" as const, label: "Contato" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-muted-foreground transition-smooth hover:text-primary"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-display text-base font-semibold">Tratamentos</h3>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/servicos/$slug"
                    params={{ slug: s.slug }}
                    className="text-muted-foreground transition-smooth hover:text-primary"
                  >
                    {s.shortTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-display text-base font-semibold">Contato</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a href={`tel:${SITE.phone}`} className="hover:text-primary">
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a href={`mailto:${SITE.email}`} className="hover:text-primary">
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>Belém — PA</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>
                  {SITE.hours.days}
                  <br />
                  {SITE.hours.open} às {SITE.hours.close}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Instagram className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a
                  href={SITE.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary"
                >
                  @podomasso
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border pt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} Podomasso Clínica de Podologia — Todos os direitos
          reservados — Belém do Pará
        </div>
      </div>
    </footer>
  );
}
